export default __webpack_public_path__ + "static/metadata-image-f6935201731f7531be030bf3a99ba398.jpg";